import PropTypes from 'prop-types';
import React, { Component } from 'react';
import enhanceWithClickOutside from 'react-click-outside';

import AddToCalendarContainer from './AddToCalendarContainer';

const CALENDARS = [
  { type: 'ical', label: 'iCalendar' },
  { type: 'google', label: 'Google Calendar' },
  { type: 'outlook', label: 'Outlook' },
  { type: 'outlookonline', label: 'Outlook Online' },
  { type: 'yahoo', label: 'Yahoo!' },
];

class AddToCalendarButton extends Component {
  constructor(props) {
    super(props);

    this.state = { show: false };

    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onButtonClick() {
    this.setState({ show: !this.state.show });
  }

  handleClickOutside() {
    this.setState({ show: false });
  }

  renderRoutes() {
    return CALENDARS.map(calendar => (
      <li key={calendar.type}>
        <a
          className="c-btn c-btn--small c-btn--secondary u-block u-mv-- u-mh"
          href={this.props.getCalendarLink(calendar.type)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {calendar.label}
        </a>
      </li>
    ));
  }


  renderDropdown() {
    return (
      <ul
        className="list-bare"
        style={{
          display: 'block',
          position: 'absolute',
          float: 'left',
          backgroundColor: '#fff',
          zIndex: 20,
          width: '100%',
        }}
      >
        {this.renderRoutes()}
      </ul>
    );
  }

  render() {
    return (
      <div className="u-position-relative">
        <button className="c-btn c-btn--secondary u-1/1" onClick={this.onButtonClick}>Add to Calendar</button>
        {this.state.show && this.renderDropdown()}
      </div>
    );
  }

}
AddToCalendarButton.propTypes = {
  getCalendarLink: PropTypes.func.isRequired,
};

export default enhanceWithClickOutside(AddToCalendarContainer(AddToCalendarButton));



// WEBPACK FOOTER //
// ./src/app/components/AddToCalendarButton.jsx